import { NotesPanel } from "./NotesPanel";

export default NotesPanel;
